import styles from './index.module.scss'

export function Loader({ isBig = false }) {
  return (
    <div className={styles.container}>
      <span className={`${styles.loader} ${isBig ? styles.big : ''}`} />
    </div>
  )
}
